/**
 * Returns true when the value can be safely converted into a finite number.
 */
export const isNumberLike = (value: unknown): value is string | number =>
  !isNaN(parseFloat(String(value))) && isFinite(Number(value));
